module.exports = __webpack_public_path__ + "5bbe09e526a70ffce6e2ba8cedc0ba64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/singapore.jpg
// module id = 647
// module chunks = 47